(function() {
    angular
        .module("customersModule", [
            "ui.router"
        ])
})()
